// src/components/forms/Button.tsx
import { FC, ReactNode } from "react";

interface Props {
  label?: string; // New prop for the label below
  children: ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
}

export const Button: FC<Props> = ({ 
  label,
  children, 
  onClick, 
  type = "button", 
  className = "",
  disabled = false 
}) => {
  return (
    <div className={`flex flex-col items-center gap-1.5 ${className}`}>
      <div className="relative group w-full">
        {/* Animated Gradient Background Glow */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-xl opacity-70 group-hover:opacity-100 transition duration-300 blur-[2px] group-active:blur-[1px]"></div>
        
        <button
          type={type}
          onClick={onClick}
          disabled={disabled}
          className="relative px-6 py-2.5 bg-white dark:bg-zinc-900 
                     text-indigo-900 dark:text-indigo-200 font-semibold
                     rounded-xl border border-zinc-200 dark:border-zinc-700
                     hover:text-indigo-600 dark:hover:text-white
                     transition-all duration-200 
                     disabled:opacity-50 disabled:cursor-not-allowed
                     active:scale-[0.98] w-full"
        >
          {children}
        </button>
      </div>

      {/* Label placed under the button */}
      {label && (
        <span className="text-xs font-semibold text-indigo-900/70 dark:text-indigo-200/70 uppercase tracking-wider">
          {label}
        </span>
      )}
    </div>
  );
};